(function () {
  const generatedTitles = new WeakMap();

  function getIframeTitle(iframe) {
    const accessibleLabel = iframe.getAttribute('aria-label')?.trim();
    if (accessibleLabel) return accessibleLabel;

    const customTitle = iframe.dataset.title?.trim();
    if (customTitle) return customTitle;

    const source = iframe.getAttribute('src');
    if (!source || source === 'about:blank') return 'Embedded content';

    try {
      const hostname = new URL(source, document.baseURI).hostname.replace(/^www\./, '');

      if (/youtube(?:-nocookie)?\.com$|youtu\.be$/.test(hostname)) return 'YouTube video player';
      if (/vimeo\.com$/.test(hostname)) return 'Vimeo video player';
      if (/google\.[^/]+$/.test(hostname) && /\/maps(?:\/|$)/.test(new URL(source, document.baseURI).pathname)) {
        return 'Google Maps';
      }
      if (/spotify\.com$/.test(hostname)) return 'Spotify player';
      if (/recaptcha\.net$|google\.com$/.test(hostname) && source.includes('recaptcha')) return 'reCAPTCHA';
      if (hostname) return `Embedded content from ${hostname}`;
    } catch (error) {
      console.warn('Error parsing iframe src URL:', error);
    }

    return 'Embedded content';
  }

  function ensureIframeTitle(iframe) {
    const currentTitle = iframe.getAttribute('title')?.trim();
    const previousGeneratedTitle = generatedTitles.get(iframe);

    if (currentTitle && currentTitle !== previousGeneratedTitle) {
      generatedTitles.delete(iframe);
      return;
    }

    const generatedTitle = getIframeTitle(iframe);
    generatedTitles.set(iframe, generatedTitle);

    if (currentTitle !== generatedTitle) iframe.setAttribute('title', generatedTitle);
  }

  function processIframes(root) {
    if (root instanceof HTMLIFrameElement) ensureIframeTitle(root);
    if (root.querySelectorAll) root.querySelectorAll('iframe').forEach(ensureIframeTitle);
  }

  function initializeIframeTitles() {
    processIframes(document);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) processIframes(node);
          });
        } else if (mutation.target instanceof HTMLIFrameElement) {
          ensureIframeTitle(mutation.target);
        }
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['title', 'src', 'aria-label', 'data-title'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeIframeTitles, { once: true });
  } else {
    initializeIframeTitles();
  }
})();
